import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const getDocuememntCalenderExpired = createAsyncThunk(
  "dashboard/getDocuememntCalenderExpired",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/calenderDataApi`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getUsercountdetails = createAsyncThunk(
  "dashboard/getusercountdetails",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/getusercountdetails`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

const workerDashboardSlice = createSlice({
  name: "workerDashboard",
  initialState: {
    expiredDocuments: [],
    userCountDetails: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocuememntCalenderExpired.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocuememntCalenderExpired.fulfilled, (state, action) => {
        state.loading = false;
        state.expiredDocuments = action.payload;
      })
      .addCase(getDocuememntCalenderExpired.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUsercountdetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsercountdetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userCountDetails = action.payload;
      })
      .addCase(getUsercountdetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default workerDashboardSlice.reducer;